import React from 'react';
import Page from '../../components/shared/Page/Page';
import StyledTable from '../../components/shared/Table/StyledTable';
import StyledTableHeader from '../../components/shared/Table/StyledTableHeader';
import UserManagementPanel from '../../components/settings/UserManagementPanel/UserManagementPanel';
import { useTranslation } from '../../hooks/useTranslation';

const UserManagement: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Page title="Elora | User Management">
      <StyledTable>
        <StyledTableHeader>
          <h1>{t('User Management')}</h1>
        </StyledTableHeader>
        <UserManagementPanel showTitle={false} />
      </StyledTable>
    </Page>
  );
};

export default UserManagement;
